<template>
  <div class="titles container">
    <div class="section-title">{{title}}</div>
    <div class="section-subtitle">{{subtitle}}</div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: ['title', 'subtitle']
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

div.titles
  padding: 65px 0 56px
  text-align: center
  +mobile
    padding: 50px 0 30px
  .section-title
    text-align: center
    font-size: 36px
    +mobile
      font-size: 26px
  .section-subtitle
    font-size: 18px
    color: #888
    +mobile
      margin-top: 5px
      font-size: 16px
</style>
